import {createElementFromHtml, escapeHtml} from '../helpers';
import ButtonComponent from './button';
import PopupComponent from './popup';

export default class PhotoComponent {
  static CLASSES = {
    PHOTO: 'photo',
    IMAGE: 'photo__image',
    BUTTONS: 'photo__buttons',
    BUTTON: 'photo__button',
    BUTTON_ZOOM: 'photo__button--zoom',
    BUTTON_DOWNLOAD: 'photo__button--download',
    BUTTON_PLAY: 'photo__button--play',
    TEXT: 'photo__text',
    DATE: 'photo__date',
    VIDEO: 'is-video'
  };

  static getButtonsHTML({srcFile, srcYoutube, popupOptions, buttonSize = 'medium'} = {}) {
    let lang = document.documentElement.lang;
    buttonSize = buttonSize === 'medium' ? null : buttonSize || null;

    let buttonZoom = popupOptions
      ? ButtonComponent.template({
          tag: 'button',
          color: 'red',
          size: buttonSize,
          text: lang === 'ru' ? 'Увеличить' : 'Zoom',
          icon: buttonSize === 'small' ? 'search-2' : 'search',
          isIconic: true,
          classList: [PhotoComponent.CLASSES.BUTTON, PhotoComponent.CLASSES.BUTTON_ZOOM]
        })
      : '';

    let buttonPlay = srcYoutube
      ? ButtonComponent.template({
          tag: 'button',
          color: 'play',
          text: lang === 'ru' ? 'Смотреть' : 'Play',
          icon: 'video-play-btn',
          isIconic: true,
          classList: [PhotoComponent.CLASSES.BUTTON, PhotoComponent.CLASSES.BUTTON_PLAY],
          data: {
            youtube: srcYoutube
          }
        })
      : null;

    let buttonDownload = srcFile
      ? ButtonComponent.template({
          tag: 'a',
          href: srcFile,
          color: 'red',
          size: buttonSize,
          text: lang === 'ru' ? 'Скачать' : 'Download',
          icon: 'download',
          isIconic: true,
          classList: [PhotoComponent.CLASSES.BUTTON, PhotoComponent.CLASSES.BUTTON_DOWNLOAD],
          download: true
        })
      : null;

    return `${buttonPlay ? buttonPlay : ''}\n${buttonDownload ? buttonDownload : ''}\n${
      buttonZoom ? buttonZoom : ''
    }`;
  }

  static template({
    classList,
    attributes,
    src,
    src2x,
    srcFile,
    srcYoutube,
    buttonSize = 'medium',
    isBackground = false,
    text = '',
    date = '',
    escapeText = true,
    popupOptions,
    popupId,
    popupItemIndex
  } = {}) {
    if (escapeText) {
      text = escapeHtml(text);
      date = escapeHtml(date);
    }

    let attrs = [
      `class="${[PhotoComponent.CLASSES.PHOTO, classList && classList.join(' ')]
        .filter((x) => x)
        .join(' ')}"`,
      popupOptions && `data-popup-options="${escapeHtml(JSON.stringify(popupOptions))}"`,
      popupId && `data-popup-id="${escapeHtml(popupId)}"`,
      popupItemIndex && `data-popup-item-index="${escapeHtml(popupItemIndex)}"`
    ];

    if (attributes) {
      attrs = attrs.concat(attributes);
    }

    attrs = attrs.filter((x) => x).join(' ');

    let photoAttrs = [
      `class="${[PhotoComponent.CLASSES.IMAGE].filter((x) => x).join(' ')}"`,
      isBackground && `style="background-image: url(${src})"`
    ]
      .filter((x) => x)
      .join(' ');

    let img = '';

    if (!isBackground) {
      let imgAttrs = [src && `src="${src}"`, src2x && `srcset="${src2x} 2x"`, `alt=""`]
        .filter((x) => x)
        .join(' ');

      img = `<img ${imgAttrs}>`;
    }

    let buttons = `<div class="${PhotoComponent.CLASSES.BUTTONS}">${PhotoComponent.getButtonsHTML({
      srcFile,
      srcYoutube,
      popupOptions,
      buttonSize
    })}</div>`;

    let photoInnerHTML = [img, buttons].filter((x) => x).join('');

    let image = `<div ${photoAttrs}>${photoInnerHTML}</div>`;

    text = text && `<figcaption class="${PhotoComponent.CLASSES.TEXT}">${text}</figcaption>`;
    date = date && `<figcaption class="${PhotoComponent.CLASSES.DATE}">${date}</figcaption>`;

    let innerHTML = [image, text, date].filter((x) => x).join('');

    return `<figure ${attrs}>${innerHTML}</figure>`;
  }

  static init($photo) {
    if (!$photo || $photo.photoComponent) {
      return;
    }

    $photo.photoComponent = new PhotoComponent($photo);
  }

  static initAll() {
    document.querySelectorAll(`.${PhotoComponent.CLASSES.PHOTO}`).forEach(($photo) => {
      PhotoComponent.init($photo);
    });
  }

  constructor($photo) {
    this.$photo = $photo;
    this.$image = $photo.querySelector(`.${PhotoComponent.CLASSES.IMAGE}`);
    this.$img = this.$image.querySelector('img');
    this.$buttons = $photo.querySelector(`.${PhotoComponent.CLASSES.BUTTONS}`);
    this.$text = $photo.querySelector(`.${PhotoComponent.CLASSES.TEXT}`);
    this.$date = $photo.querySelector(`.${PhotoComponent.CLASSES.DATE}`);

    this.onClick = this.onClick.bind(this);

    this.init();
  }

  init() {
    this.$photo.addEventListener('click', this.onClick);
  }

  destroy() {
    this.$photo.removeEventListener('click', this.onClick);
    this.$photo.photoComponent = null;
  }

  onClick(event) {
    var $target = event.target;

    if ($target.closest(`.${PhotoComponent.CLASSES.BUTTON_ZOOM}`)) {
      this.$buttonZoom = this.$photo.querySelector(`.${PhotoComponent.CLASSES.BUTTON_ZOOM}`);
      this.eventZoom(event);
    }

    if ($target.closest(`.${PhotoComponent.CLASSES.BUTTON_PLAY}`)) {
      this.$buttonPlay = this.$photo.querySelector(`.${PhotoComponent.CLASSES.BUTTON_PLAY}`);
      this.eventPlay(event);
    }
  }

  eventZoom(event) {
    event.preventDefault();
    let popupId = this.$photo.dataset.popupId;
    let popupItemIndex = this.$photo.dataset.popupItemIndex;
    let $popup;

    if (popupId) {
      $popup = document.getElementById(popupId);
    } else {
      let popupOptions = JSON.parse(this.$photo.dataset.popupOptions || '{}');
      let popupHtml = PopupComponent.template(popupOptions);

      $popup = createElementFromHtml(popupHtml);
      document.body.appendChild($popup);
    }

    if (this.player) {
      this.player.pauseVideo();
    }

    PopupComponent.init($popup);

    if (popupItemIndex !== undefined) {
      $popup.popupComponent.isLoading = true;
      $popup.popupComponent.toSlide(popupItemIndex, {skipResize: true}).then(() => {
        $popup.popupComponent.open();
      });
    } else {
      $popup.popupComponent.open();
    }
  }

  eventPlay(event) {
    event.preventDefault();
    var youtubeSrc = this.$buttonPlay.dataset['youtube'];

    if (youtubeSrc) {
      var youtubeIdMatches = youtubeSrc.match(
        /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
      );

      if (youtubeIdMatches && youtubeIdMatches[1]) {
        var youtubeId = youtubeIdMatches[1];

        if (window.youTubeIframeAPIReady) {
          this.playYoutube(youtubeId);
        } else {
          PhotoComponent.loadYoutubeApi(() => {
            this.playYoutube(youtubeId);
          });
        }
      }
    }
  }

  playYoutube(youtubeId) {
    var $iframe = this.$photo.querySelector('iframe');
    if ($iframe) {
      $iframe.remove();
    }
    var $image = this.$photo.querySelector('img');
    var $placeholder = document.createElement('div');
    $placeholder.id = `player-${Date.now()}`;
    $image.parentNode.insertBefore($placeholder, $image);
    this.$photo.classList.add(PhotoComponent.CLASSES.VIDEO);

    this.player = new YT.Player($placeholder.id, {
      width: $image.offsetWidth,
      height: $image.offsetHeight,
      videoId: youtubeId,
      hl: document.documentElement.lang,
      iv_load_policy: 3,
      modestbranding: 1,
      showinfo: 0,
      rel: 0,
      fs: 0,
      events: {
        onReady: (event) => {
          this.$iframe = event.target.getIframe();
          this.$iframe.style.width = `${$image.offsetWidth}px`;
          this.$iframe.style.height = `${$image.offsetHeight}px`;
          event.target.playVideo();
        }
      }
    });
  }

  updateSrc({src, src2x, srcFile, srcYoutube, popupOptions, buttonSize} = {}) {
    return new Promise((resolve, reject) => {
      if (src === this.$img.src) {
        resolve();
      } else {
        let $img = new Image();

        $img.src = src;

        if (src2x) {
          $img.srcset = `${src2x} 2x`;
        } else {
          $img.removeAttribute('srcset');
        }

        $img.onload = () => {
          if (this.$iframe) {
            this.$photo.classList.remove(PhotoComponent.CLASSES.VIDEO);
            this.$iframe.remove();
          }

          if (this.$buttons) {
            this.$buttons.innerHTML = PhotoComponent.getButtonsHTML({
              srcFile,
              srcYoutube,
              popupOptions,
              buttonSize
            });
          }

          this.$img.src = src;
          resolve();
        };

        $img.onerror = reject;
      }
    });
  }

  updatePopupOption(popupOptions) {
    this.$photo.dataset.popupOptions = JSON.stringify(popupOptions || {});
  }

  updateText(text, date) {
    this.$img.alt = text;

    this.$text = this.$photo?.querySelector(`.${PhotoComponent.CLASSES.TEXT}`);
    this.$date = this.$photo?.querySelector(`.${PhotoComponent.CLASSES.DATE}`);

    this.$text ? (this.$text.innerText = text) : null;
    this.$date ? (this.$date.innerText = date) : null;
  }

  update(options) {
    return new Promise((resolve, reject) => {
      this.updateSrc(options)
        .then(() => {
          this.updateText(options.text, options.date);
          this.updatePopupOption(options.popupOptions);
          resolve();
        })
        .catch(reject);
    });
  }

  waitLoad(force = false) {
    return new Promise((resolve, reject) => {
      if (!this.$img.naturalWidth || !this.$img.naturalHeight || force) {
        let onLoad = () => {
          this.$img.removeEventListener('load', onLoad);
          resolve();
        };

        let onError = () => {
          this.$img.removeEventListener('error', onError);
          reject();
        };

        this.$img.addEventListener('load', onLoad);
        this.$img.addEventListener('error', onError);
      } else {
        resolve();
      }
    });
  }

  setSize(width, height) {
    let imageWidth = width;
    let imageHeight = height;
    let photoHeight = this.$photo.offsetHeight;

    if (this.$text) {
      this.$text.style.width = `${width}px`;

      if (height > width || height + this.$text.offsetHeight > photoHeight) {
        if (height >= photoHeight) {
          height = photoHeight;
        }
        imageHeight = height - this.$text.offsetHeight;
        imageWidth = (imageHeight * width) / height;
      }

      this.$text.style.width = `${imageWidth}px`;
    }

    if (this.$date) {
      this.$date.style.width = `${imageWidth}px`;
    }

    this.$img.style.width = `${imageWidth}px`;
    this.$img.style.height = `${imageHeight}px`;

    if (this.$buttons) {
      this.$buttons.style.width = `${imageWidth}px`;
    }

    if (this.$iframe) {
      this.$iframe.style.width = `${imageWidth}px`;
      this.$iframe.style.height = `${imageHeight}px`;
    }
  }

  static loadYoutubeApi(callback) {
    window.onYouTubeIframeAPIReady = function () {
      window.youTubeIframeAPIReady = true;
      if (typeof callback === 'function') {
        callback();
      }
    };

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.async = true;

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}
